
import React from "react";
import { Link } from "react-router-dom";
import HeaderBottom from "../assets/header-bottom-shap.png"
import { useTranslation } from 'react-i18next'

const HelpCenter = () => {
    const { t } = useTranslation();
  return (
    <>    
    <main className="main position-relative">
      <div className="bottom-main-shap position-absolute top-0">
        <img src={HeaderBottom} alt="" />
      </div>
      {/* Help Search Section */}
      <div className="help-search py-md-5 py-4 text-center position-relative z-1">
        <div className="container">
        <h1>{t("title")}</h1>
        <p>{t("subtitle")}</p>
          <div className="input-group mt-3 w-75 mx-auto">
            <input
              type="text"
              className="form-control"
              id="faqSearch"
              placeholder="Search for help..."
            />
            <button className="btn btn-primary">
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Category Cards */}
      <div className="help-categories py-md-5 py-4 position-relative z-1">
        <div className="container">
          <h3 className="text-center mb-4">{t("popularTopics")}</h3>
          <div className="row g-4 text-center">
            <div className="col-lg-3 col-md-6">
              <div className="card h-100 shadow category-card">
                <div className="card-body">
                  <i className="fas fa-plane fa-2x text-primary mb-3"></i>
                  <h5 className="mb-2">{t("flightBookingTitle")}</h5>
                  <p>{t("flightDesc")}</p> 
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card h-100 shadow category-card">
                <div className="card-body">
                  <i className="fas fa-hotel fa-2x text-primary mb-3"></i>
                  <h5 className="mb-2">{t("hotelTitle")}</h5>
                  <p>{t("hotelDesc")}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card h-100 shadow category-card">
                <div className="card-body">
                  <i className="fas fa-credit-card fa-2x text-primary mb-3"></i>
                  <h5 className="mb-2">{t("paymentTitle")}</h5>
                  <p>{t("paymentDesc")}</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card h-100 shadow category-card">
                <div className="card-body">
                  <i className="fas fa-ban fa-2x text-primary mb-3"></i>
                  <h5 className="mb-2">{t("cancelTitle")}</h5>
                  <p>{t("cancelDesc")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="faq-section py-md-5 py-4">
        <div className="container">
          <h3 className="text-center pb-4">{t("faqTitle")}</h3>

          <div className="accordion faq-sec trip-right-sec" id="faqAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="q1">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#a1"
                  aria-expanded="true"
                  aria-controls="a1"
                >
                  {t("q1")}
                </button>
              </h2>
              <div
                id="a1"
                className="accordion-collapse collapse show"
                aria-labelledby="q1"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  {t("a1")}{" "}
                  <Link href="tel:18004536744">1-800-453-6744</Link>.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="q2">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#a2"
                  aria-expanded="false"
                  aria-controls="a2"
                >
                  {t("q2")}
                </button>
              </h2>
              <div
                id="a2"
                className="accordion-collapse collapse"
                aria-labelledby="q2"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                {t("a2")}
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="q3">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#a3"
                  aria-expanded="false"
                  aria-controls="a3"
                >
                  {t("q3")}
                </button>
              </h2>
              <div
                id="a3"
                className="accordion-collapse collapse"
                aria-labelledby="q3"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                {t("a3")}
                  <Link href="mailto:support@travelx.com">
                    support@travelx.com
                  </Link>
                  .
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Support */}
      <div className="contact-support py-md-5 py-4 text-center">
        <div className="container">
        <h3>{t("contactTitle")}</h3>
        <p>{t("contactSubtitle")}</p>
          <p>
            <strong>{t("phone")}:</strong>{" "}
            <Link href="tel:18004536744">1-800-453-6744</Link> |{" "}
            <strong>{t("Email")}:</strong>{" "}
            <Link href="mailto:support@travelx.com">support@travelx.com</Link>
          </p>
        </div>
      </div>
      </main>
    </>
  );
};

export default HelpCenter;
